module.exports = __webpack_public_path__ + "static/media/vertica.82d895be.svg";